import { customer } from '@icabbi/api-gateway-client';
import { Authentication } from '@icabbi/vue-authentication';

const defaultState = {
  userServiceClient: null,
  me: {},
  meDisplayName: '',
  meLoading: false,
};

const getters = {
  meDisplayName: state => state.meDisplayName,
  roles: () => [
    { name: 'fleetAdmin' },
    { name: 'paymentManager' },
    { name: 'paymentReadOnly' },
  ],

  // eslint-disable-next-line no-shadow
  userServiceClient: (state, getters, rootState, rootGetters) => ({ dispatch }) => {
    if (state.userServiceClient === null) {
      const authentication = Authentication({ dispatch, getters: rootGetters });
      const { authenticationFailureInterceptor, bearerTokenInterceptor } = authentication;
      const userServiceClient = new customer.UserServiceConnector({
        baseURL: process.env.VUE_APP_API_GATEWAY_URL,
        timeout: parseInt(process.env.VUE_APP_HTTP_REQUEST_TIMEOUT, 10),
      });
      userServiceClient.httpClient.interceptors.response.use(undefined, error => authenticationFailureInterceptor(error));
      userServiceClient.httpClient.interceptors.request.use(config => bearerTokenInterceptor(config));
      state.userServiceClient = userServiceClient;
    }
    return state.userServiceClient;
  },

};

// eslint-disable-next-line no-underscore-dangle

const getUserRoles = (role) => {
  const roles = [{ name: role }];
  return roles;
};


const actions = {
  async getMe(context) {
    try {
      context.commit('setMeLoading', true);
      const userServiceClient = context.getters.userServiceClient(context);

      const me = await userServiceClient.getMe();

      context.commit('setMe', me);
      context.commit('setMeDisplayName', `${me.givenName} ${me.familyName}`);
      context.commit('setMeLoading', false);
      return me;
    } catch (error) {
      // eslint-disable-next-line no-console
      console.log(error);
      context.dispatch('globalMessages/addError', { message: 'user.userRetrievalError' }, { root: true });
      context.commit('setMeLoading', false);
      return false;
    }
  },
  async createUser(context, {
    givenName, familyName, role, email, communicationLanguage,
  }) {
    try {
      const userServiceClient = context.getters.userServiceClient(context);

      const roles = getUserRoles(role);

      const result = await userServiceClient.createUser({
        data: {
          givenName, familyName, roles, email, communicationLanguage,
        },
      });

      context.dispatch(
        'globalMessages/addSuccess',
        { message: 'user.userCreated' },
        { root: true },
      );
      return result;
    } catch (error) {
      // eslint-disable-next-line no-console
      console.log(error);
      context.dispatch(
        'globalMessages/addError',
        { message: 'user.userError', code: error.code ? error.code : '' },
        { root: true },
      );
      return { errorCode: error.httpStatusCode ? error.httpStatusCode : '500' };
    }
  },

  async updateUser(context, {
    id, givenName, familyName, role, email, communicationLanguage,
  }) {
    try {
      const userServiceClient = context.getters.userServiceClient(context);

      const roles = getUserRoles(role);

      const result = await userServiceClient.updateUser({
        id, givenName, familyName, roles, email, communicationLanguage,
      });

      context.dispatch(
        'globalMessages/addSuccess',
        { message: 'user.userUpdated' },
        { root: true },
      );
      return result;
    } catch (error) {
      // eslint-disable-next-line no-console
      console.log(error);
      context.dispatch(
        'globalMessages/addError',
        { message: 'user.userUpdatedError', code: error.code ? error.code : '' },
        { root: true },
      );
      return { errorCode: error.httpStatusCode ? error.httpStatusCode : '500' };
    }
  },

  async deleteUser(context, { id }) {
    try {
      const userServiceClient = context.getters.userServiceClient(context);
      const result = await userServiceClient.deleteUser({ id });
      context.dispatch(
        'globalMessages/addSuccess',
        { message: 'user.userDeleted' },
        { root: true },
      );
      return result;
    } catch (error) {
      // eslint-disable-next-line no-console
      console.log(error);
      context.dispatch(
        'globalMessages/addError',
        { message: 'user.deleteUserError', code: error.code ? error.code : '' },
        { root: true },
      );
      return { errorCode: error.httpStatusCode ? error.httpStatusCode : '500' };
    }
  },

  async listUsers(context, {
    page, maxPerPage, sort, dynamicSearch,
  }) {
    try {
      const userServiceClient = context.getters.userServiceClient(context);
      const users = await userServiceClient.listUsers({
        sort,
        page,
        maxPerPage,
        dynamicSearch,
      });
      return users;
    } catch (error) {
      // eslint-disable-next-line no-console
      console.log(error);
      context.dispatch(
        'globalMessages/addError',
        { message: 'user.getUsersError', code: error.code ? error.code : '' },
        { root: true },
      );
      return { errorCode: error.httpStatusCode ? error.httpStatusCode : '500' };
    }
  },
};

const mutations = {
  setMe(state, me) {
    state.me = me;
  },
  setMeDisplayName(state, displayName) {
    state.meDisplayName = displayName;
  },
  setMeLoading(state, meLoading) {
    state.meLoading = meLoading;
  },
};

export default {
  namespaced: true,
  state: defaultState,
  getters,
  actions,
  mutations,
};
